// extracted by mini-css-extract-plugin
module.exports = {"r19uj99":"r19uj99","b1xoy3x3":"b1xoy3x3"};